export default function initializeHeroSlider() {
    document.querySelectorAll('.block-hero-slider').forEach(function (block) {
        new HeroSlider(block);
    });
}

class HeroSlider {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        import('swiper/bundle').then(({ default: Swiper }) => {
            new Swiper(this.block.querySelector('.block-hero-slider__swiper'), {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                speed: 1500,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
            });
        });
    }
}
